import { SET_PRACTICE_STEP, SET_LEVEL, SET_START_LEVEL, SET_INTRODUCED, SET_OPTIONS, PAUSE, SET_MODE } from './actions';
import { LOADING_GAME, SHOW_INTRO } from './actions';
import { SET_SCORE, SET_TIME_LEFT, SET_LEVELS_COMPLETED, UPDATE_STATS } from './actions';
import { GOTO_PAGE } from '../../HOME/REDUX/actions';
import * as f from '../logic';
import { STATS_KEY } from '../const';
import { dbdel } from '../../HOME/utils';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_MODE:
      return { ...state, mode: action.mode };
    case SET_PRACTICE_STEP:
      return { ...state, practiceStep: action.practiceStep };
    case SET_LEVELS_COMPLETED:
      return { ...state, levelsCompleted: action.levelsCompleted };
    case SET_LEVEL:
      return { ...state, level: action.level };
    case SET_START_LEVEL:
      return { ...state, startLevel: action.startLevel };
    case GOTO_PAGE:
      return { ...state, page: action.payload.page };
    case SET_TIME_LEFT:
      const time = action.timeLeft;
      return { ...state, timeLeft: time === undefined ? f.levelInfo(state.level).time + 2 : time };
    case SET_SCORE:
      const { hits, misses, score } = action.payload;
      return { ...state, hits, misses, score };
    case SET_INTRODUCED:
      return { ...state, introduced: action.introduced };
    case UPDATE_STATS:
      const { plays, aggScore, best } = action.payload;
      if (!plays) {
        dbdel(STATS_KEY);
      }
      const average = plays ? Math.round((aggScore || 0) / plays) : 0;
      const stats = { plays: plays || 0, aggScore, average, best: best || 0 };
      return { ...state, stats };
    case SET_OPTIONS:
      return { ...state, options: action.options || {} };
    case PAUSE:
      return { ...state, paused: action.on };
    case LOADING_GAME:
      return { ...state, loadingGame: action.on, paused: true };
    case SHOW_INTRO:
      return { ...state, intro: action.show };
    default:
      return state;
  }
};
